import { apiClient } from "./client";

export type SearchPractitioner = { id: string; display_name: string; rpps: string | null };
export type SearchOrganization = { id: string; code: string; name: string };
export type SearchSkill = { id: string; code: string; label: string };

export type SearchResults = {
  practitioners: SearchPractitioner[];
  organizations: SearchOrganization[];
  skills: SearchSkill[];
};

export async function globalSearch(q: string): Promise<SearchResults> {
  const { data } = await apiClient.get<SearchResults>("/api/v1/me/search", {
    params: { q },
  });
  return data;
}
